import React, { useEffect, useState } from 'react';
import { useResume } from '../context/ResumeContext';
import { ADDITONAL_PREDEFINE_SECTIONS, MONTHS, SKILL_LEVEL } from '../constants/constants';
import DeleteIcon from '../assets/images-new/icons/bin-icon.svg';
import { usePopup } from '../context/PopupContext';
import { removeBodyScroll } from '../helper';
import SkillsStarRating from './common/SkillsStarRating';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd'
import DraggableIcon from '../assets/images/draggable-icon.svg';

const Languages = (props) => {
  const {
    resume: {
      heading: { fname },
      languages,
      enabled_tabs
    },
    handlers: {
      updateResumePreview,
    },
  } = useResume();
  const confirmbox = usePopup();
  const rating_disabled = languages.rating_disabled ?? true
  const grid = languages.grid ?? {};
  const emptyrow = ADDITONAL_PREDEFINE_SECTIONS.languages.struct.grid.row_1
  const [checkField, setCheckField] = useState('');
  useEffect(() => {
    if (!languages.hasOwnProperty('grid')) {
      let struct = { ...emptyrow };
      struct.content = languages.content;
      updateResumePreview({ languages: { ...languages, grid: { row_1: { ...struct } } } });
    }

  }, []);

  const updateRow = (input, id) => {
    const row = {
      [id]: {//example certifications_1
        ...grid[id],
        ...input
      }
    }
    updateResumePreview(
      { languages: { ...languages, grid: { ...grid, ...row } }, current_tab: 'additional_sections',  }
    )
  }
  const addRow = (newname = '') => {
    const id = 'row_' + Math.floor(Math.random() * 1000)
    const row = { ...emptyrow }
    updateResumePreview(
      { languages: { ...languages, grid: { ...grid, [id]: { ...row } } }, current_tab: 'additional_sections',  }
    )
  }
  const deleteRow = (id) => {
    if (grid.hasOwnProperty(id)) {
      let t = { ...grid }
      delete t[id]
      if (!Object.keys(t).length) {//Last need to handle with default settings
        const newid = 'row_' + Math.floor(Math.random() * 1000)
        t = { [newid]: { ...emptyrow } }
      }
      updateResumePreview({ languages: { ...languages, grid: { ...t } }, current_tab: 'additional_sections' })
    }
  }
  const fieldFocus = (e, id) => {
    setCheckField(e.target.name + '-' + id)
  }
  const fieldBlur = (e, id) => {
    setCheckField('');
  }
  const updateRatingDisability = (input) => {
    updateResumePreview(
      { languages: { ...languages, grid: { ...grid }, rating_disabled: input.rating_disabled } }
    )
  }

  const TabStatus = props => <div className="arrow" onClick={props.onClick}> {props.t ? <i className="icon-right-arrow"></i> : <i className="icon-chevron-left"></i>}</div>;
  
  const onDragEnd = result => {
    const { destination, source, draggableId } = result;
    if (!destination) return
    if (destination.droppableId === source.droppableId && destination.index === source.index) return
    const grid1 = {};
    let ids = Object.keys(languages.grid), grid = {};
    ids.splice(source.index, 1)
    ids.splice(destination.index, 0, draggableId)
    ids.forEach(element => {
      const id = 'row_' + Math.floor(Math.random() * 1000)
      grid1[id] = { ...languages.grid[element] }
      //grid1.push( { ...section.grid[element] })
      })
    updateResumePreview(
      { 
        languages: { 
          ...languages, 
          grid: {...grid1},
        }, current_tab: 'additional_sections',  }
    )    
  }
  
  return (<DragDropContext onDragEnd={onDragEnd}>
  <div className="editor-form languages-blocks">
    <div className="button-wrap">
        <div className={`on-off-btn${rating_disabled ? ' disabled' : ' light-blue' }`}>
          <p>
            <input
              type="checkbox"
              id="rating_disabled"
              defaultChecked={rating_disabled ? false : true}
              onChange={e => updateRatingDisability({ rating_disabled: !rating_disabled })}
            />
            <span><i></i></span> Show experience level
          </p>
        </div>
    </div>
    <Droppable droppableId={'unrelavent'}>
    {(provided) => (
      <div className="skills-wrap" ref={provided.innerRef} {...provided.droppableProps}>
        {Object.keys(grid).map((id, index) => (
          <Draggable draggableId={id} index={index} key={id}>
            {(provided, snapshot) => (
              <div className={`skills-list-wrap ${grid[id].open ? 'open' : ''}`} key={id}  ref={provided.innerRef} {...provided.draggableProps}>
                <div className="skills-block" onClick={() => (updateRow({ open: !grid[id].open }, id))}>
                  {/* <div className="reorder-wrap"><DraggableIcon /></div> */}
                  <div className="skill">
                      <div className="reorder re-order-lang">
                                <div type="button" className="btn btn-link" dataid={id} {...provided.dragHandleProps}><DraggableIcon /></div>
                        </div>
                    <h2>{grid[id].name.length ? grid[id].name : 'Not Specified'} 
                    {!rating_disabled ? <span> - {grid[id].expertise_level ? SKILL_LEVEL[grid[id].expertise_level - 1] : 'Expert'}</span> : ''}
                    </h2>
                    <div className="delete-wrap show-inside" onClick={(e) => {confirmbox.show('row_delete', null, () => deleteRow(id)), removeBodyScroll(true)}}>
                      <DeleteIcon />
                    </div>
                    <TabStatus t={grid[id].open} onClick={() => (updateRow({ open: !grid[id].open }, id))} />
                    {/* <div className="arrow"><i className="icon-chevron-left"></i> </div> */}
                  </div>

                </div>
                <div className="label-field"> <label className={`label${checkField == 'name-' + id ? ' label-focus' : ''}`}>Language</label></div>
                {grid[id].open && <div className={`skill-form${!rating_disabled ? '' : ' block-full'}`}>
                  <div className={`skill-field`}>
                    <input
                      type="text"
                      name="name"
                      className="form-input lang-input"
                      value={grid[id].name}
                      onChange={(e) => updateRow({ name: e.target.value }, id)}
                      onFocus={(e) => fieldFocus(e, id)}
                      onBlur={(e) => fieldBlur(e, id)}
                    />
                  </div>
                  {!rating_disabled ? <div className="skill-level">
                    <label className="label">Expertise </label>
                    <div className="rating-box-wrap">
                      <div className="rating-box">
                        <SkillsStarRating
                          value={grid[id].expertise_level}
                          updateRating={(r) => {
                            updateRow({ expertise_level: r }, id);
                          }} />
                      </div>
                    </div>
                  </div> : '' }
                </div>}
              </div>
            )}
          </Draggable>
        ))}
       {provided.placeholder}
      </div>
     )}
     </Droppable>
    <div className="add-more-wrap">
      <span className="add-more-skills" onClick={() => addRow()}><i className="icon-plus-icon" ></i> Add more languages</span>
    </div>
  </div>
  </DragDropContext>);
}

export default Languages;